<form [formGroup]="form">
  @switch (step) {
    @case (1) {
      <div class="row">
        <div class="col-md-12 form-group">
          <p>{{ 'workflow.default.help_text' | translate }}</p>
          <label>{{ 'workflow.default.template' | translate }}</label>
          <app-input-with-error
            [control]="this.form.controls['workflowTemplateId']"
            [inputType]="'select'"
            [translateSelect]="false"
            [selectValues]="workflowTemplateIds"
            [selectNames]="workflowTemplateNames"
          ></app-input-with-error>
          <div
            (click)="nextStep()"
            [ngClass]="{ disabled: !isDefaultSelected() }"
            class="btn btn-secondary w-100 mt-2"
          >
            {{ 'next' | translate }}
          </div>
        </div>
      </div>
    }
    @case (2) {
      <div class="row">
        <div class="col-md-6 form-group">
          <label>{{ 'workflow.name' | translate }}</label>
          <app-input-with-error
            [control]="this.form.controls['name']"
          ></app-input-with-error>
        </div>
        <div class="col-md-6 form-group">
          <label>{{ 'workflow.identifier' | translate }}</label>
          <app-input-with-error
            [control]="this.form.controls['identifier']"
          ></app-input-with-error>
        </div>
        <div class="col-md-6 form-group">
          <label>{{ 'workflow.dataconnection' | translate }}</label>
          <app-input-with-error
            [control]="this.form.controls['dataConnectionId']"
            [inputType]="'select'"
            [translateSelect]="false"
            [selectDefaultText]="'workflow.dataconnection_none' | translate"
            [selectValues]="[''].concat(dataConnectionIds)"
            [selectNames]="
              ['workflow.dataconnection_none' | translate].concat(
                dataConnectionNames
              )
            "
          ></app-input-with-error>
        </div>
        @if (shouldShowDashboardReplacement()) {
          <div class="col-md-12 form-group mt-3">
            <div class="d-flex align-items-center gap-2">
              <p-checkbox
                inputId="replaceDashboard"
                formControlName="replaceDashboard"
                [binary]="true"
              />
              <label for="replaceDashboard" class="mb-0">
                {{ 'workflow.replaceDashboard' | translate }}
              </label>
            </div>
            @if (!selectedTemplateHasDashboard()) {
              <div class="form-text">
                {{ 'workflow.replaceDashboardUnavailable' | translate }}
              </div>
            } @else if (!this.form.controls['dataConnectionId'].value) {
              <div class="form-text">
                {{
                  'workflow.replaceDashboardDataConnectionRequired' | translate
                }}
              </div>
            } @else {
              <div class="form-text text-warning">
                {{ 'workflow.replaceDashboardWarning' | translate }}
              </div>
            }
          </div>
        }
        <div class="col-md-6 form-group">
          <label>{{ 'workflow.idle' | translate }}</label>
          <div class="d-flex align-items-center gap-2">
            <p-checkbox
              inputId="isIdle"
              formControlName="isIdle"
              [binary]="true"
            />
            <label for="isIdle" class="mb-0">
              {{ 'workflow.isIdle' | translate }}
            </label>
          </div>
          <div class="form-text">{{ 'workflow.idle?' | translate }}</div>
        </div>
        <div class="col-md-4 form-group">
          <label>{{ 'workflow.imageOrPdf' | translate }}</label>
          <p-fileupload
            [disabled]="!editable || form.disabled || uploadingFile"
            styleClass="ms-3"
            mode="basic"
            name="demo[]"
            chooseIcon="pi pi-upload"
            accept="image/*, application/pdf, .html"
            [customUpload]="true"
            (uploadHandler)="onUpload($event)"
            [auto]="true"
            [chooseLabel]="'browse' | translate"
          />
          @if (hasFile()) {
            <p-button
              type="button"
              severity="danger"
              [outlined]="true"
              icon="pi pi-trash"
              [label]="'workflow.removeFile' | translate"
              [disabled]="!editable || form.disabled || uploadingFile"
              (onClick)="removeFile()"
              data-testid="remove-workflow-file"
            />
          }

          <div class="form-text mb-2">
            {{ 'workflow.imageOrPdf-help' | translate }}
          </div>
        </div>
        <div class="col-md-8">
          <div class="workflow-preview">
            @if (previewType === 'pdf') {
              <object
                [data]="previewResourceUrl"
                type="application/pdf"
                width="100%"
                height="100%"
              ></object>
            } @else if (previewType === 'image') {
              <img
                [src]="previewUrl"
                alt="Uploaded Image"
                style="max-width: 100%; max-height: 200px"
              />
            } @else if (previewType === 'iframe') {
              <iframe
                [src]="previewResourceUrl"
                sandbox="allow-same-origin allow-scripts"
                referrerpolicy="no-referrer"
                loading="lazy"
                style="width: 100%; height: 100%"
              >
              </iframe>
            } @else if (previewType === 'html') {
              <iframe
                [src]="previewResourceUrl"
                sandbox=""
                referrerpolicy="no-referrer"
                loading="lazy"
                style="width: 100%; height: 100%"
              >
              </iframe>
            }
          </div>
        </div>
        <div class="col-md-12 form-group">
          <label>{{ 'workflow.embedString' | translate }}</label>
          <app-input-with-error
            [control]="this.form.controls['embedString']"
            [inputType]="'textarea'"
          ></app-input-with-error>
        </div>
        <div class="col-md-12 form-group">
          <label>{{ 'workflow.description' | translate }}</label>
          <app-input-with-error
            [control]="this.form.controls['description']"
            [inputType]="'textarea'"
            helpText="{{ 'error.maxlengthValue' | translate: { max: 255 } }}"
          ></app-input-with-error>
        </div>
      </div>
    }
  }
  <app-error [error]="error"></app-error>
</form>
